import { PUBLIC_ACCOUNTS_URL } from '@/lib/api';
import { useAuthAccountsStore } from '@/stores/authAccounts';
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import router from '.';

// Check if the user is logged in. If not, redirect to login.
export async function authGuard(
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext
) {
  if (to.query.token) {
    router.replace({ path: to.path, query: { ...to.query, token: undefined } });
  }
  const accountsStore = useAuthAccountsStore();
  const check = await accountsStore.check();
  if (!check) {
    login();
    return false;
  }
  next();
}

// Check if the user is an admin. If not, redirect to login.
export function adminGuard(_to: RouteLocationNormalized, _from: RouteLocationNormalized, next: NavigationGuardNext) {
  const accountsStore = useAuthAccountsStore();
  if (!accountsStore.accounts.some(account => account.claims?.admin)) {
    login();
    return false;
  }
  next();
}

function login() {
  const currentLocation = window.location.href;
  window.location.href = `${PUBLIC_ACCOUNTS_URL}/auth/login?redirect=${currentLocation}`;
}
